module.exports = "/assets/dist/images/SamsungGear.png?1380794737c1fd8f5219e1e870c8d636";